// Choose active component for build and dev
// import CustomPage from '@custom/app/CustomPage.vue';

interface CreateVueCustomPage extends Window {
  createVueCustomPage(): void;
}

declare const window: CreateVueCustomPage;

export function createVueCustomPage() {
  // return CustomPage;
}

window.createVueCustomPage = createVueCustomPage;
